export enum UserSettingKeys {
    language = "language",
    units = "units",
}
